<div style="width: 10%">
  <p *ngIf="loadingSuggestionArr" class="mb-0" style="font-family: &quot;Lato&quot;; font-weight: 600; font-size: 16px; line-height: 1">
    Cargando
  </p>

  <div class="d-flex flex-column">
    <p style="font-family: &quot;Lato&quot;; font-weight: 600; font-size: 16px; margin: 0">Sugerencias.</p>
    <div class="w-100 d-flex align-items-center justify-content-end">
      <i
        class="bi bi-arrow-right-short d-flex align-items-center justify-content-center"
        style="background-color: #000000; color: #ffffff; border-radius: 50%; font-size: 1.1rem; width: 25px; height: 25px"
      ></i>
    </div>
  </div>
</div>

<div *ngIf="loadingSuggestionArr" class="d-flex" style="width: 86%; gap: 1.5em">
  <!-- Placeholder 1 -->
  <div class="suggestion-placeholder card border-0 m-0" style="box-shadow: none">
    <div class="card-body p-0">
      <div
        class="d-flex justify-content-between align-items-center px-4"
        style="
          height: 130px;
          border-radius: 12px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 2.5s infinite;
        "
      >
        <div class="d-flex flex-column justify-content-between" style="width: 50%; height: 50%">
          <div class="placeholder-line" style="height: 16px; width: 80%; margin-bottom: 8px"></div>
          <div class="placeholder-line" style="height: 14px; width: 60%"></div>
        </div>

        <div class="d-flex flex-column justify-content-center align-items-center" style="gap: 1em; width: 50%">
          <div class="placeholder-circle" style="width: 125px; height: 45px; border-radius: 50rem"></div>
          <div class="placeholder-button" style="width: 125px; height: 42px; border-radius: 0.375rem"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Placeholder 2 -->
  <div class="suggestion-placeholder card border-0 m-0" style="box-shadow: none">
    <div class="card-body p-0">
      <div
        class="d-flex justify-content-between align-items-center px-4"
        style="
          height: 130px;
          border-radius: 12px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 2.5s infinite;
        "
      >
        <div class="d-flex flex-column justify-content-between" style="width: 50%; height: 50%">
          <div class="placeholder-line" style="height: 16px; width: 80%; margin-bottom: 8px"></div>
          <div class="placeholder-line" style="height: 14px; width: 60%"></div>
        </div>

        <div class="d-flex flex-column justify-content-center align-items-center" style="gap: 1em; width: 50%">
          <div class="placeholder-circle" style="width: 125px; height: 45px; border-radius: 50rem"></div>
          <div class="placeholder-button" style="width: 125px; height: 42px; border-radius: 0.375rem"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!loadingSuggestionArr" class="d-flex" style="width: 86%; gap: 1.5em">
  <ng-container *ngFor="let suggestions of suggestionsArr.slice(0, 2)">
    <ng-container *ngIf="suggestions?.categoryId === 6 || suggestions?.categoryId === 9">
      <div
        class="d-flex justify-content-between w-100 p-4"
        style="padding-right: 10px !important; position: relative; height: 130px;border-radius: 12px;
                                background-image: linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('{{
          suggestions?.additionalInfo?.images[0]?.thumbnail
        }}');
                                background-size: cover;
                                background-position: center;
                                background-repeat: no-repeat;"
      >
        <div class="d-flex flex-column justify-content-between" style="width: 100%">
          <div
            class="mb-0 suggestion-title-multiline"
            style="font-family: &quot;Rubik&quot;, serif; font-size: 18.5px; font-weight: 600; color: white; line-height: 1"
            tooltip="{{ suggestions?.title }}"
            placement="bottom"
          >
            {{ suggestions?.title }}
          </div>
          <div
            class="mb-0"
            style="font-family: &quot;Rubik&quot;, serif; font-size: 12.3px; color: white; line-height: 1; font-weight: 500"
          >
            Duración: {{ getDurations(suggestions?.additionalInfo?.tours?.options) }}
          </div>
        </div>
        <div class="d-flex flex-column justify-content-end align-items-end w-100">
          <div
            class="d-flex flex-column justify-content-center px-3"
            style="
              background-color: #FFFFFF;
              border-radius: 16px;
              min-height: 50px;
              border: 3.36px solid;
              margin-bottom: 10px;
            "
            [ngStyle]="{ 'border-color': clientSetting?.clients_setting_global?.color_main_1 }"
          >
            <p
              class="mb-0"
              style="
                font-family: 'Rubik', sans-serif;
                font-size: 10px;
                line-height: 1
              "
            >
              Desde
            </p>
            <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 600; line-height: 1">
              {{ currencyAgency?.code }} {{ getPrice(suggestions) | number: "1.2-2" }}
            </p>
          </div>

          <div class="w-100 d-flex align-items-center justify-content-end">
            <button
              type="button"
              class="btn rounded btn-block px-2"
              style="
                color: #000000;
                font-family: 'Rubik', sans-serif;
                font-size: 14px;
                font-weight: 500;
                width: 100px;
                height: 32px;
              "
              [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_1 }"
              (click)="openModal(suggestions, suggestions?.payload)"
            >
              Seleccionar
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="suggestions?.category === 8">
      <div
        class="d-flex flex-column justify-content-between w-100 p-4"
        [ngStyle]="{ 'background-color': styleBody?.card_background_price }"
        style="border-radius: 15px; border: 2px solid #c2c2c3; height: 130px"
      >
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-column align-items-start" style="width: 100%">
            <p class="mb-1 title-suggestion" style="font-family: 'Rubik'; font-size: 20px; font-weight: 600; line-height: 1">
              Traslado
            </p>

            <p
              *ngIf="suggestions?.title"
              style="
                font-size: 12.35px;
                font-family: 'Rubik';
                font-weight: 400;
                line-height: 1;
              "
            >
              {{ suggestions?.title }}
            </p>
          </div>

          <div>
            <img src="../../../../../../../assets/icons/search-box/bus.svg" style="width: 36px" alt="" />
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-column justify-content-end" style="width: 100%">
            <p class="mb-0" style="line-height: 1; font-family: 'Rubik'; font-size: 12.36px; font-weight: 400">Traslado desde: </p>

            <p
              class="mb-0"
              *ngIf="suggestions?.payload?.categoriesId[0] === 8"
              style="line-height: 1; font-family: 'Rubik'; font-size: 14px; font-weight: 500"
            >
              {{ currencyAgency?.code }} {{ getPrice(suggestions) | number: "1.2-2" }}
            </p>
          </div>
          <button
            type="button"
            class="btn rounded btn-block px-2 mx-auto"
            style="font-family: 'Rubik', serif; font-size: 14px; font-weight: 500; width: 130px; height: 32px; color: #000000"
            (click)="openModal(suggestions, suggestions?.payload)"
            [ngStyle]="{
              'background-color': clientSetting?.clients_setting_global?.color_main_1
            }"
          >
            Seleccionar
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="suggestions?.category === 10">
      <div
        class="d-flex flex-column justify-content-between w-100 p-4"
        [ngStyle]="{ 'background-color': styleBody?.card_background_price }"
        style="border-radius: 15px; border: 2px solid #c2c2c3; height: 130px"
      >
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-column align-items-start" style="width: 100%">
            <p class="mb-1 title-suggestion" style="font-family: 'Rubik'; font-size: 20px; font-weight: 600; line-height: 1">
              Asistencia
            </p>
          </div>

          <div>
            <img src="../../../../../../../assets/img/app/categories-search-box/icon-seguro.svg" style="width: 36px" alt="" />
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-column justify-content-end" style="width: 100%">
            <p class="mb-0" style="line-height: 1; font-family: 'Rubik'; font-size: 12.36px; font-weight: 400">Asistencia desde: </p>

            <p
              class="mb-0"
              *ngIf="suggestions?.payload?.categoriesId[0] === 10"
              style="line-height: 1; font-family: 'Rubik'; font-size: 14px; font-weight: 500"
            >
              {{ currencyAgency?.code }} {{ getPrice(suggestions) | number: "1.2-2" }}
            </p>
          </div>
          <button
            type="button"
            class="btn rounded btn-block px-2 mx-auto"
            style="font-family: 'Rubik', serif; font-size: 14px; font-weight: 500; width: 130px; height: 32px; color: #000000"
            (click)="openModal(suggestions, suggestions?.payload)"
            [ngStyle]="{
              'background-color': clientSetting?.clients_setting_global?.color_main_1
            }"
          >
            Seleccionar
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
